export type UserEventType = (typeof USER_EVENTS)[keyof typeof USER_EVENTS];

export const USER_EVENTS = {
  ADDON_ONBOARDING_SESSION_STARTED: 'ADDON_ONBOARDING_SESSION_STARTED',
  ADDON_ONBOARDING_WELCOME_VIEWED: 'ADDON_ONBOARDING_WELCOME_VIEWED',
  ADDON_ONBOARDING_TEST_VIEWED: 'ADDON_ONBOARDING_TEST_VIEWED',
  ADDON_ONBOARDING_TEST_SENT: 'ADDON_ONBOARDING_TEST_SENT',
  ADDON_ONBOARDING_OUTCOME_ARRIVED: 'ADDON_ONBOARDING_OUTCOME_ARRIVED',
  ADDON_ONBOARDING_OUTCOME_NOT_ARRIVED: 'ADDON_ONBOARDING_OUTCOME_NOT_ARRIVED',
  ADDON_ONBOARDING_SEND_EXHAUSTED: 'ADDON_ONBOARDING_SEND_EXHAUSTED',
  ADDON_ONBOARDING_ACTIVATION_OPENED: 'ADDON_ONBOARDING_ACTIVATION_OPENED',
  ADDON_ONBOARDING_CONSENT_VIEWED: 'ADDON_ONBOARDING_CONSENT_VIEWED',
  APPOINTMENT_BOOKING_DISMISSED: 'APPOINTMENT_BOOKING_DISMISSED',
  AUTO_REMINDERS_CALLOUT_ACTIVATED: 'AUTO_REMINDERS_CALLOUT_ACTIVATED',
  AUTO_REMINDERS_CALLOUT_DEACTIVATED: 'AUTO_REMINDERS_CALLOUT_DEACTIVATED',
  AUTO_REMINDERS_MODAL_SEEN: 'AUTO_REMINDERS_MODAL_SEEN',
  FEEDBACK_SURVEY_MODAL_SEEN: 'FEEDBACK_SURVEY_MODAL_SEEN',
  G2_CAPTERRA_REVIEW_MODAL_SEEN: 'G2_CAPTERRA_REVIEW_MODAL_SEEN',
  KALAMA_TEASER_WEB_BANNER_SEEN: 'KALAMA_TEASER_WEB_BANNER_SEEN',
  KALAMA_TEASER_WEB_POPUP_SEEN: 'KALAMA_TEASER_WEB_POPUP_SEEN',
  KALAMA_TEASER_ADDON_CARD_SEEN: 'KALAMA_TEASER_ADDON_CARD_SEEN',
  KALAMA_TEASER_ADDON_HOME_ROW_SEEN: 'KALAMA_TEASER_ADDON_HOME_ROW_SEEN',
  KALAMA_RENAMED_WEB_POPUP_SEEN: 'KALAMA_RENAMED_WEB_POPUP_SEEN',
  FIRST_EVENT_ACTIVATED: 'FIRST_EVENT_ACTIVATED',
  GOOGLE_API_QUOTA_EXCEEDED: 'GOOGLE_API_QUOTA_EXCEEDED',
  GOOGLE_TOKEN_ERROR_EMAIL_SENT: 'GOOGLE_TOKEN_ERROR_EMAIL_SENT',
  LOGGED_IN: 'LOGGED_IN',
  INSTALL_CHROME_EXTENSION_MODAL_SEEN: 'INSTALL_CHROME_EXTENSION_MODAL_SEEN',
  PAUSED_REMINDERS_MODAL_SEEN: 'PAUSED_REMINDERS_MODAL_SEEN',
  SUBSCRIPTION_ENDED_MODAL_SEEN: 'SUBSCRIPTION_ENDED_MODAL_SEEN',
  REVIEW_FIRST_EVENT_MODAL_SEEN: 'REVIEW_FIRST_EVENT_MODAL_SEEN',
  SET_AND_FORGET_PROMO_MODAL_SEEN: 'SET_AND_FORGET_PROMO_MODAL_SEEN',
  SHOPIFY_WORDPRESS_SURVEY_MODAL_SEEN: 'SHOPIFY_WORDPRESS_SURVEY_MODAL_SEEN',
  MANUAL_STANDING_PHONE_CONSENT_GRANTED:
    'MANUAL_STANDING_PHONE_CONSENT_GRANTED',
  STANDING_CONSENT_DEMOTED_WRONG_NUMBER:
    'STANDING_CONSENT_DEMOTED_WRONG_NUMBER',
} as const;
